<template>
    <div>
        <HeadIndex v-on:HeadIndexSearch="HeadIndexSearch($event)"></HeadIndex>
        <el-row>
            <el-col :xs="{ span: 24, offset: 0 }" :sm="{ span: 24, offset: 0 }" :md="{ span: 22, offset: 1 }"
                :lg="{ span: 22, offset: 1 }" :xl="{ span: 18, offset: 3 }" class="custom-col-20 offset-col-2">
                <div class="Page_heading" style="border-radius: 10px;">
                    <el-row class="">
                        <el-col :span="24" class="">
                            <div ref="height_top">
                                <el-table :row-style="addStyle" :cell-style="cellStyle" @row-click="rowClick"
                                    :row-class-name="tableRowClassName" :data="tableData" @row-dblclick="rowDblclick"
                                    :height="tableHeight" :header-cell-style="{ 'background-color': '#e5e5e5' }"
                                    size="small" v-loading="loading" style="width: 100%;border-radius: 10px;">
                                    <el-table-column prop="img" label="实图" width="80" header-align="center"
                                        show-overflow-tooltip>
                                        <template #default="scope">
                                            <div v-if="scope.row.img.length <= 0">
                                                <div @click="preview(scope.row, scope.row.img)">
                                                    <el-image style="" :src="require('@/assets/img/error_img.png')"
                                                        loading="lazy" />
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div @click="preview(scope.row, scope.row.img)">
                                                    <el-image :src="scope.row.img[0]" loading="lazy" />
                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="" label="" width="20" />
                                    <el-table-column prop="stock_type_txt" label="货物状态" header-align="center"
                                        width="170" show-overflow-tooltip>
                                        <template #default="scope">
                                            <div class="stock_type_txt_button">
                                                <span v-for="item in scope.row.stock_type_txt_list">
                                                    <el-button class="A" size="small" text bg
                                                        v-if="item == '二手' || item == '过保' || item == '包附破损'"
                                                        style="">{{ item }}</el-button>
                                                    <el-button class="C" size="small" text bg v-else color="#ff8a5c">{{
                                                        item }}</el-button>
                                                </span>
                                            </div>
                                            <!-- <el-button-group class="ml-4">
										    <el-button size="small"/>
										    <el-button size="small" />
										    <el-button size="small" />
										  </el-button-group> -->
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="" label="" width="20" />
                                    <el-table-column prop="brand_name" label="产品信息" 
                                        show-overflow-tooltip>
                                        <template #default="scope">
                                            <div class="product-info">
                                                <div class="product-tags">
                                                    <el-tag  type="danger" v-if="scope.row.issus==1"
                                                        size="small">疑似关联</el-tag>
                                                   
                                                </div>
                                                <div class="brand-name" v-if="scope.row.brand_name">
                                                    {{ scope.row.brand_name }}
                                                </div>
                                                <div class="product-name" v-if="scope.row.name">
                                                    {{ scope.row.name }}
                                                </div>
                                                <div class="product-details" v-if="scope.row.model">
                                                    <span class="detail-label">型号</span><span
                                                        class="label-colon">：</span>
                                                    <span class="detail-value">{{ scope.row.model }}</span>
                                                </div>
                                                <div class="product-details" v-if="scope.row.order_no">
                                                    <span class="detail-label">订货号</span><span
                                                        class="label-colon">：</span>
                                                    <span class="detail-value">{{ scope.row.order_no }}</span>
                                                </div>
                                                <div class="product-details" v-if="scope.row.unit">
                                                    <span class="detail-label">单位</span><span
                                                        class="label-colon">：</span>
                                                    <span class="detail-value">{{ scope.row.unit }}</span>
                                                </div>
                                                <div class="product-user-type" v-if="scope.row.type_name">
                                                    <span class="detail-label">用户类型</span><span
                                                        class="label-colon">：</span>
                                                    <span class="detail-value">{{ scope.row.type_name }}</span>
                                                </div>
                                                <span
                                                    v-if="!scope.row.brand_name && !scope.row.name && !scope.row.model && !scope.row.order_no">
                                                    -
                                                </span>
                                                <div class="product-details" v-if="scope.row.unit">
                                                    
                                                    <span class="detail-value">
                                                        <el-button size="small" style="color: #ffffff; background-color: #ff8a5c; border-color: #ff8a5c;">疑似关联</el-button>
                                                    </span>
                                                    
                                                </div>
                                            </div>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="" label="" width="20" />
                                    <el-table-column prop="tsw_price" align="center" header-align="center" label="单价" :width="td_width['tsw_price']"
                                        show-overflow-tooltip>

                                        <template #default="scope">
                                            <el-tooltip placement="top">
                                                <template #content>
                                                    <p>此信息由用户提供</p>
                                                    <p>列表价格：{{ scope.row.price }}</p>
                                                    <p>折扣：{{ scope.row.tsw_discount }}</p>
                                                </template>
                                                <span class="price-value">{{ scope.row.tsw_price }}</span>
                                            </el-tooltip>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="" label="" width="20" />
                                    <el-table-column prop="sur_num" label="库存" :width="td_width['sur_num']" align="center" header-align="center" show-overflow-tooltip>
                                        <template #default="scope">
                                            <div class="stock-cell">
                                                <span class="stock-value">{{ scope.row.sur_num }}</span>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="" label="" width="20" />
                                    <el-table-column prop="num_input" label="数量" width="230" align="center" header-align="center" show-overflow-tooltip>
                                        <template #default="scope">
                                            <div style="margin: 10px" @click.stop @dblclick.stop>
                                                <el-input-number class="num-input" v-model="scope.row.num_input" :min="1" :max="scope.row.sur_num" @change="handleChange" @click.stop @dblclick.stop />
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column prop="type_name" label="用户类型" width="130" show-overflow-tooltip /> -->
                                    <el-table-column prop="" label="聊天" :width="td_width['chat']">
                                        <template #default="scope">
                                            <span>
                                                <el-icon size="18" @click="chat_click(scope.row.id)"
                                                    style="color:var(--el-color-primary)">
                                                    <ChatDotSquare />
                                                </el-icon>
                                                <!-- <el-icon size="18">
													<ShoppingCart />
												</el-icon> -->
                                                <!-- <el-icon size="18">
													<Edit />
												</el-icon> -->
                                                <!-- <el-icon size="18" style="color:#ff8a5c">
													<WarnTriangleFilled @click="report(scope.row.id)"/>
												</el-icon> -->
                                            </span>
                                            <!-- <el-icon style=" color: red "  size="20"  class="report_ico" @click="ShoppingCart(scope.row.id)">
												<ShoppingCart size="20" />
											</el-icon> -->
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="" label="" width="20" />

                                </el-table>
                            </div>
                        </el-col>
                        <el-col :span="24" ref='pagination' style="display: flex; justify-content: flex-end;">
                            <el-pagination :pager-count="5" size="small" class="pagination" :current-page="page"
                                background :page-size="parseInt(page_size)" prev-text="上一页" next-text="下一页"
                                layout="prev,pager, next" @current-change="handleCurrentChange" :total="total">
                            </el-pagination>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>
        <el-row class="logo_m">
            <el-col :span="24">
                <div>
                    CopyRight © 脱手网 2018 苏ICP备18008659号
                </div>
            </el-col>
        </el-row>
        <examineImg ref="examineImg"></examineImg>
        <chat ref="chat" v-if="chat_info" v-on:closeChat="closeChat($event)"></chat>
    </div>
</template>
<script>
import '../../assets/search/index.css' //优化表格样式
import { ElMessage, ElMessageBox } from 'element-plus'
import HeadIndex from '../public/HeadIndex';
import examineImg from '../public/img';
import chat from '../public/chat';
export default {
    name: 'search',
    components: {
        HeadIndex,
        examineImg,
        chat
    },
    data() {

        return {
            td_width: {
                brand_name: 300,
                tsw_price: 180,
                sur_num: 180,
                chat: 60,
                price: 80
            },
            chat_info: false,
            index: [],
            srcList: [],
            tableHeight: 500,
            loading: false,
            total: 0,
            page: 1,
            page_size: 20,
            form: {},
            input3: '',
            select: '',
            filter: '',
            stock_type: '',
            img_info: '',
            tableData: [],
            user_id: '',
        }
    },
    props: [],

    updated() {

    },

    watch: {
        filter(val, newval) { }
    },
    mounted() {
        this.$nextTick(() => {
            const element = this.$refs.pagination.$el;
            const rect = element.getBoundingClientRect();
            //console.log(rect)

        });
        this.getScreenWidthRange()
        console.log();
    },

    activated() {

    },
    created() {
        this.user_id = localStorage.getItem('user_id');
        this.filter = this.$route.query.filter
        this.stock_type = this.$route.query.stock_type
        this.search();
        this.tableHeight_fun();
    },

    methods: {
        handleChange(val) {
            console.log(val);
        },
        getScreenWidthRange() {
            // 获取视口宽度（推荐用这个，适配响应式开发）
            const viewportWidth = document.documentElement.clientWidth;
            // 若需获取屏幕物理宽度，替换为：const screenWidth = screen.width;

            let range = '';
            // 区间判断（左闭右开：1200 ≤ 宽度 < 1600；960 ≤ 宽度 < 1200）
            if (viewportWidth >= 1300 && viewportWidth < 1600) {
                range = '1300-1600';
                this.td_width = {
                    brand_name: 300,
                    tsw_price: 150,
                    sur_num: 150,
                    chat: 60,
                    price: 80
                };
            } else if (viewportWidth >= 960 && viewportWidth < 1300) {
                range = '960-1300';
                this.td_width = {
                    brand_name: 300,
                    tsw_price: 70,
                    sur_num: 70,
                    chat: 60,
                    price: 80
                };
            } else if (viewportWidth >= 1600) {
                range = '≥1600';
            } else {
                range = '<960';
            }

            return {
                width: viewportWidth,
                range: range
            };
        },
        rowClick(row, column, e) {
            this.index = [parseInt(row.index)] //选中行this.tabClickcolumn = 1
        },
        tableRowClassName({
            row,
            rowIndex
        }) {
            row.index = rowIndex
            if (this.index.indexOf(rowIndex) > -1) {
                return 'selected'
            }
            return ''
        },
        addStyle({ row, rowIndex }) {
            if (this.index.indexOf(rowIndex) > -1) {
                return { 'border': '1px solid #ff8a5c !important' }
            }
        },
        cellStyle({ columnIndex }) {
            if (columnIndex === 0) {
                return { 'background-color': '#fff  !important' }
            }
        },
        closeChat() {
            this.chat_info = false;
        },
        async chat_click(id) {
            await this.$axios.post('/api/yunsys.storage/addchat', { id }).then(async (res) => {
                var res = res.data;
                if (res.code !== 0) {
                    return ElMessage({
                        message: res.msg,
                        type: 'error',
                        grouping: true // 开启合并功能
                    })
                };
                this.chat_info = false;
                this.$nextTick(() => {
                    this.chat_info = true;
                    this.$nextTick(() => {
                        this.$refs['chat'].dialogTableVisible = true;
                        this.$refs['chat'].pitch_id = res.data.data;
                        this.$refs['chat'].admin_pitch_id = res.data.data; //维护一个不变的数据 这个需要告诉后台是从哪里点进来的
                        this.$nextTick(() => {
                            this.$refs['chat'].search()
                        })
                    })
                })

            })
                .catch(err => {
                    return ElMessage({
                        message: '系统错误',
                        type: 'error',
                        grouping: true // 开启合并功能

                    })
                })
        },
        tableHeight_fun() {
            this.$nextTick(() => {
                this.tableHeight = window.innerHeight - this.$refs.height_top.getBoundingClientRect().top - 100
            })
        },
        ShoppingCart(id) {
            ElMessageBox.prompt('请填写数量！', '加入购物车', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                inputValue: '1'

            })
                .then(({ value }) => {

                })
                .catch(() => {

                })
        },
        report(id) {
            ElMessageBox.prompt('请填写举报理由！', '举报', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',

            })
                .then(({ value }) => {

                })
                .catch(() => {

                })
        },
        preview(row, img) {
            this.srcList = [];
            /*this.srcList_index = 0
            this.showPreview = true;*/
            var obj = this;
            img.forEach(function (item) {
                obj.srcList.push(item)
            })
            this.$refs['examineImg'].img_title = row;
            this.$refs['examineImg'].data = this.srcList;
            this.$refs['examineImg'].dialogTableVisible = true;
            this.$refs['examineImg'].imgBigUrl = this.srcList[0];
        },
        rowDblclick(row) {
            const newUrl = this.$router.resolve({ path: '/product', query: { id: row.id } }).href;
            window.open(newUrl, '_blank');
        },
        HeadIndexSearch(val) {
            this.filter = val.filter
            this.stock_type = val.stock_type
            this.page = 1;
            this.search();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.search();
        },
        async search() {
            if (this.loading) {
                return false;
            }
            this.loading = true;

            // 1. 先将 this.stock_type 字符串按逗号分割为数组（处理空值情况）
            const stockTypeStr = this.stock_type || ''; // 确保不是 undefined/null
            const stockTypeArr = stockTypeStr.split(','); // 分割为数组：["滞纳、过保、包附完好", "2"]

            // 2. 初始化变量
            let stock_type = ''; // 货物类型（非1、2的选项）
            let img_infoArr = []; // 图片类型（1、2的选项）
            let img_info = ''; // 最终拼接后的图片类型字符串
            let order_no_associate = ''; // 疑似
            let model_associate = ''; // 疑似

            // 3. 遍历分割后的数组，分离图片类型和货物类型
            if (stockTypeArr.length > 0) {
                stockTypeArr.forEach(item => {
                    // 去除选项前后可能存在的空格（避免分割后有多余空格影响判断）
                    const trimItem = item.trim();
                    // 判断是否为图片类型（值为'1'或'2'，字符串类型）
                    if (trimItem === '1' || trimItem === '2') {
                        img_infoArr.push(trimItem);
                    } else if (trimItem === '3' || trimItem === '4') {
                        order_no_associate = trimItem;
                    } else if (trimItem === '5') {
                        model_associate = trimItem;
                    } else {
                        // 货物类型拼接（多个货物类型用逗号分隔，适配后端格式）
                        stock_type = stock_type ? `${stock_type},${trimItem}` : trimItem;
                    }
                });

                // 4. 图片类型数组转为字符串（如 '2' 或 '1,2'）
                img_info = img_infoArr.join(',');
            }

            // 5. 构造请求参数
            var search = {
                page: this.page,
                ps: this.page_size,
                filter: this.filter,
                stock_type: stock_type,
                img_info: img_info,
                order_no_associate: order_no_associate,
                model_associate: model_associate,
            };

            await this.$axios.post('/api/yunsys.Storage/getstorage', search)
                .then(async (res) => {
                    var res = res.data;
                    this.loading = false;
                    if (res.code !== 0) {
                        return ElMessage({
                            message: res.msg,
                            type: 'error',
                            grouping: true // 开启合并功能
                        });
                    }
                    var obj = this;
                    this.total = 99999999999;
                    res.data.forEach(item => {
                        item.stock_type_txt_list = item.stock_type_txt.split("、");
                        item.num_input = 1;
                        if (obj.user_id) {
                            item.real_money = obj.$bn.multiply(item.sur_num, item.real_price, 2);
                            item.real_price = obj.$bn.multiply(item.real_price, 1, 2);
                            item.tsw_price = obj.$bn.multiply(item.tsw_price, 1, 2);
                            item.tsw_discount = obj.$bn.divide(item.tsw_price, item.price, 3);
                        } else {
                            item.real_money = '*';
                            item.real_price = '*';
                            item.discount_calculate = '*';
                            item.sur_num = '*';
                        }
                    });
                    this.tableData = res.data;
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
                    return ElMessage({
                        message: '系统错误',
                        type: 'error',
                        grouping: true // 开启合并功能
                    });
                });
        },
    }
}
</script>
<style lang="less" scoped>
:deep(.el-page-header__header) {

    line-height: 32px;
    margin-left: 30px;
}

:deep(.acquiesce .el-button:hover) {
    color: #fff;
    background-color: #ff8a5c;
    border-color: #ff8a5c;
    border: 0;
}

:deep(.el-pager .number) {
    display: none
}

:deep(.el-pager .more) {
    display: none
}



:deep(.el-table__row .el-table__cell:nth-child(2)) {
    .el-tooltip {
        padding: 0px;
    }
}

.stock_type_txt_button .el-button {
    margin-right: 5px;
    font-size: 0.70rem !important;
    padding: 0.2525rem 0.5875rem;
}

.stock_type_txt_button .A {
    color: #ff8a5c;
    background-color: rgb(255, 240, 228) !important;
}

.stock_type_txt_button .B {
    color: red;
    background-color: rgb(255, 243, 245) !important;
}

.stock_type_txt_button .C {
    color: rgb(75, 212, 205);
    background-color: rgb(223, 255, 251) !important;
}

:deep(.el-input-group__append) {
    background: #ff8a5c;
}
:deep(.num-input .el-input__wrapper){
    box-shadow: 0 0 0 1px var(--el-input-border-color,var(--el-border-color)) inset !important;
}


:deep(.district .el-input-group__prepend) {
    background-color: #fff;
    color: #ff8a5c;
}

:deep(.district .el-input-group__append) {
    background-color: #fff;
    color: #ff8a5c;
}

:deep(.el-image) {
    border-radius: 3px;
    height: 60px;
    width: 60px;
    display: inline-block;
    display: flex;
}

:deep(.acquiesce .el-button) {

    border: 0;
}

:deep(.info .el-button:hover) {
    color: #fff;
    background-color: #ff8a5c;
    border-color: #ff8a5c;
}

:deep(.name .el-button:hover) {
    color: #ff8a5c;
}

:deep(.name .el-button:active) {
    color: #ff8a5c;
}

:deep(.el-pagination.is-background .el-pager li.is-active) {
    background-color: #ff8a5c;
}

:deep(.el-form-item__label) {
    font-size: 13px;
}

:deep(.el-form-item) {

    margin-bottom: 8px;
}
:deep(.el-input-group__append) {

	background: #ff8a5c;
}
.logo_m {
    margin: 15px 0px 15px 0px;
    height: auto;
}

.product-info {
    padding: 8px 0;
}

.product-tags {
    margin-bottom: 6px;
}

.product-tags .el-tag {
    margin-right: 6px;
    margin-bottom: 4px;
}

.brand-name {
    font-weight: bold;
    color: #333;
    font-size: 14px;
    margin-bottom: 4px;
}

.product-name {
    color: #666;
    font-size: 13px;
    margin-bottom: 4px;
}

.product-details {
    color: #999;
    font-size: 12px;
    margin-bottom: 3px;
    display: flex;
    align-items: center;
}

.detail-label {
    display: inline-block;
    width: 48px;
    text-align: justify;
    text-align-last: justify;
    text-justify: inter-character;
}

.label-colon {
    margin-right: 8px;
}

.detail-value {
    flex: 1;
}

.product-user-type {
    color: #666;
    font-size: 12px;
    margin-top: 4px;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.price-value {
    color: #ff8a5c;
    font-size: 16px;
    font-weight: bold;
}

.price-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.inquiry-btn {
    color: #ff8a5c;
    font-size: 13px;
    padding: 0;
}

.inquiry-btn:hover {
    color: #ff6b3d;
}

.off-shelf {
    color: #999;
    font-size: 12px;
}

.stock-cell {
    //display: flex;
   
    height: 100%;
}

.stock-value {
    font-size: 13px;
    color: #333;
}

.chat-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

:deep(.el-table__body-wrapper tr.el-table__row.selected) td {
    border-top: 1px solid #ff8a5c !important;
    border-bottom: 1px solid #ff8a5c !important;
}

:deep(.el-table__body-wrapper tr.el-table__row.selected td:first-child) {
    border-left: 1px solid #ff8a5c !important;
}

:deep(.el-table__body-wrapper tr.el-table__row.selected td:last-child) {
    border-right: 1px solid #ff8a5c !important;
}
</style>